import Raven from 'raven-js';

export default class RuntimeTools {
    static updateIntercomDetails(details) {
        window.Intercom('update', {
            name: details.name,
            email: details.email,
            first_name: details.first_name,
            middle_name: details.middle_name,
            last_name: details.last_name,
            phone: details.phone,
            signed_up: details.signed_up,
            user_id: details.user_id,
            user_hash: details.user_hash
        });
    }

    static updateFullstoryDetails(details) {
        window.FS.identify(details.user_id, {
            displayName: details.name,
            email: details.email,
            firstName_str: details.first_name,
            middleName_str: details.middle_name,
            lastName_str: details.last_name,
            phone_str: details.phone,
            signedUp_date: details.signed_up
        });
    }

    static setRavenContext(email, userType) {
        Raven.setUserContext({
            email: email,
            type: userType
        });
    }
}


// WEBPACK FOOTER //
// ./src/util/RuntimeTools.js